"use strict";

import "../common/tablesort_numeric";
import "../common/tablesort_time";
import "./frozen-headers";

import dataSorter from "../viewing-summary/summary-report-table-sorter";
import leadingZeroes from "../common/lead-zeroes";
import removeInitialViewClass from "../common/remove-initial-view-class";
import fileDownloader from "../common/file-downloader";
import renderViewingSummaryReportCSV from "./render-monthly-viewing-summary-report-csv";
import numberFormat from "../common/number-format";

export default (dataUrl, options = {}) => sb => {
    let form;
    let currentData;
    let initialFire = false;

    const SVOD_TABLE = "2";

    const renderReport = data => {
        let report = sb.find("table.main-summary");
        let reportSVOD = sb.find("table.svod-summary");
        let body = report.query("tbody");
        let bodySVOD = reportSVOD.query("tbody");
        let tableHeaders = report.query("#headers");
        let tableSVODHeaders = reportSVOD.query("#headers-svod");

        hidePleaseWait();
        sb.empty(tableHeaders).append(tableHeaders, renderTableReportHeader());
        sb.empty(tableSVODHeaders).append(tableSVODHeaders, renderTableReportHeader());

        const standardData = data.filter(row => row.table !== SVOD_TABLE);
        const SVODData = data.filter(row => row.table === SVOD_TABLE);

        sb.empty(body).append(body, renderReportTable(standardData));
        sb.empty(bodySVOD).append(bodySVOD, renderReportTable(SVODData));

        report.css("display", "inline-table");
        reportSVOD.css("display", "inline-table");
        sb.notify({type: "tableUpdated"});

        toggleNoDataMsg(standardData.length, SVODData.length);

        removeInitialViewClass(sb);
    };

    const downloadCSV = data => {
        fileDownloader(
            renderViewingSummaryReportCSV(data, {
                showTotal: 1
            }),
            'Monthly-Viewing-Summary.csv',
            'text/csv;charset=utf-8'
        );
    };

    const onClickDownloadCSV = () => {
        showPleaseWait();
        getData()
            .then(data => {
                downloadCSV(dataSorter(data))
            })
            .then(hidePleaseWait);
    };

    const showPleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "block");
    };

    const toggleNoDataMsg = (show = true, showSVOD = true) => {
        sb.find("#no-data-field").css("display", show ? 'none': 'block');
        sb.find("#report-table-data").css("display", show ? 'block' : 'none');

        sb.find("#no-SVOD-data-field").css("display", showSVOD ? 'none': 'block');
        sb.find("#report-SVOD-table-data").css("display", showSVOD ? 'block' : 'none');
    };

    const hidePleaseWait = () => {
        let wait = sb.find("div.scroll_datagrid .wait");
        wait.css("display", "none");
    };

    const onFormSubmit = e => {
        e.preventDefault();

        showPleaseWait();
        getData().then(
            data => {
                currentData = dataSorter(data);
                return renderReport(currentData);
            }
        );
    };

    const getData = () => {
        return sb.postApi(dataUrl, {
            method: "POST",
            year: jQuery('#period_year').val(),
            month: jQuery('#period_month').val()
        })
    }

    const renderTableReportHeader = () => {
        return `<th data-sort-method="text" class="number no_bold align_right"></th>` +
            `<th data-sort-method="number" class="number no_bold align_right bleft-white tiv">000s</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tiv">%</th>` +
            `<th data-sort-method="number" class="percentage no_bold align_right tiv">%</th>` +
            `<th data-sort-method="time" class="minutage no_bold align_right tiv">MM:SS</th>`;
    }

    const renderReportTable = data => {
        return data.map(
            (row, i) => {
                let rowClass = "";
                let nullValueSymbol = "-";

                if (row.bold === '1') {
                    rowClass = "no-sort summary";
                } else {
                    rowClass = "standard";
                }

                return `<tr data-channel-type="${(row.channel_type)}" id="station_${row.station_name}" class="${rowClass}">` +
                    `<td>${row.station_name}</td>` +
                    `<td class="number align_right bleft-white tiv">${Number(row.monthly_reach_000) >= 0 ? Number(row.monthly_reach_000).toLocaleString() : nullValueSymbol}</td>` +
                    `<td class="percentage align_right tiv">${Number(row.monthly_reach_percentage) >= 0 ? Number(row.monthly_reach_percentage).toLocaleString() : nullValueSymbol}</td>` +
                    `<td class="share align_right tiv">${Number(row.total_identified_viewing) >= 0 ? numberFormat(row.total_identified_viewing, 2) : nullValueSymbol}</td>` +
                    `<td class="minutage align_right tiv">${Number(row.avg_min) >= 0 && Number(row.avg_sec) >= 0? `${row.avg_min}:${leadingZeroes(row.avg_sec)}` : nullValueSymbol}</td>` +
                    `</tr>`;
            }
        ).join("\n");
    }

    return {
        init() {
            form = sb.find("form");

            sb.addEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);
            sb.addEvent(form, "submit", onFormSubmit);

            jQuery(document).ajaxStop(function () {
                if (!initialFire && options.periodIdField === undefined) {
                    initialFire = true;
                    sb.find("#button_submit")[0].click();
                }
            });


            sb.listen({
                tableFilter: filter => {
                    if (currentData) {
                        renderReport(currentData, filter, filter.length > 0);
                    }
                }
            });
        },
        destroy() {
            sb.ignore(["periodsSelectionChanged", "tableFilter"]);

            sb.removeEvent(form, "submit", onFormSubmit);
            sb.removeEvent(sb.find("#button_download_trigger"), "click", onClickDownloadCSV);

            form = null;
        }
    }
};

